module.exports = __webpack_public_path__ + "img/MY.25bf6dce.svg";